module.exports = __webpack_public_path__ + "assets/img/29_300_big.7a4392b4.jpg";